// extracted by mini-css-extract-plugin
export default {"markdown":"EledoArticleView_markdown__EDbki","sidebar":"EledoArticleView_sidebar__Lnkm3"};